import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { toFrontendUser } from '../../lib/backendAdapters';

const requestBrowserNotificationPermission = async () => {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return;
  }

  if (Notification.permission !== 'default') {
    return;
  }

  try {
    await Notification.requestPermission();
  } catch (error) {
    console.warn('Nao foi possivel solicitar permissao de notificacao.', error);
  }
};

const AdminLoginPage: React.FC = () => {
  const { isAuthenticated, user, login } = useAuthStore();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  if (isAuthenticated) {
    const destination = user?.role === 'platform' ? '/platform' : user?.role === 'owner' ? '/admin' : '/staff';
    return <Navigate to={destination} replace />;
  }

  const handleLogin = async (event?: React.FormEvent) => {
    if (event) event.preventDefault();

    try {
      setIsLoading(true);
      setError(null);

      const { api } = await import('../../lib/api');
      const response = await api.post('/auth/login', { email, password });

      login(toFrontendUser(response.data.user), response.data.access_token);
      await requestBrowserNotificationPermission();
    } catch (requestError: any) {
      setError(requestError.response?.data?.message || 'Erro ao realizar login');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <form onSubmit={handleLogin} className="w-full max-w-sm animate-slide-in-up space-y-8">
        <div className="space-y-2 text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-primary to-primary-hover shadow-glow-primary">
            <span className="text-2xl font-black text-white">G</span>
          </div>
          <h1 className="text-2xl font-bold text-white">Garçom Digital</h1>
          <p className="text-sm text-muted-foreground">Acesse a plataforma, o painel do restaurante ou a operacao</p>
        </div>

        <div className="card space-y-4 p-6">
          {error && (
            <div className="rounded-lg border border-red-500/50 bg-red-500/20 p-3 text-sm text-red-500">
              {error}
            </div>
          )}

          <div className="space-y-2">
            <label className="text-sm font-medium text-white">E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="input"
              placeholder="owner@seurestaurante.com.br"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-white">Senha</label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="input"
              placeholder="Digite sua senha"
            />
          </div>

          <button type="submit" disabled={isLoading} className="btn-primary mt-2 w-full py-3 disabled:opacity-50">
            {isLoading ? 'Entrando...' : 'Entrar'}
          </button>
        </div>

        <p className="text-center text-xs text-muted-foreground">
          Use as credenciais da sua conta para acessar.
        </p>
      </form>
    </div>
  );
};

export default AdminLoginPage;
